import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import html2canvas from 'html2canvas';
import { ModalDirective } from 'ngx-bootstrap/modal';
import jsPDF from 'jspdf';

import { PositionFacade } from '../../../common/facade/PositionFacade';
import { PositionStoreFacade } from '../../../common/facade/PositionStoreFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { Position } from '../../../common/model/Position';
import { InventoryCountFacade } from '../../../common/facade/InventoryCountFacade';
import { InventoryCountTag } from '../../../common/model/InventoryCountTag';
import { InventoryCount } from '../../../common/model/InventoryCount';
import { InventoryCountFilter } from '../../../common/model/InventoryCountFilter';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { CatalogDetInfo } from '../../../common/model/dictionary/CatalogDetInfo';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { OrganizationFacade } from '../../../common/facade/OrganizationFacade';
import { Organization } from '../../../common/model/Organization';
import { ConfigurationFacade } from '../../../common/facade/ConfigurationFacade';
import { ConfigurationInfo } from '../../../common/model/dictionary/ConfigurationInfo';
import { Configuration } from '../../../common/model/Configuration';
import { Store } from '../../../common/model/Store';


// declare var jsPDF: any;
declare var JsBarcode: any;
declare var setPosId: any;
declare var checkPrinterStatus: any;
declare var printText: any;
declare var getPosData: any;
declare var requestPrint: any;
declare var cutPaper: any;
declare var printBitmap: any;
declare var $: any;

@Component({
  selector: 'app-inventory-count-create',
  templateUrl: './inventory-count-create.component.html',
  styleUrls: ['./inventory-count-create.component.css']
})
export class InventoryCountCreateComponent implements OnInit {
  res = res;
  isSpanish = true;
  language = 0;
  isUSAStore = false;
  organizationId: string = null;
  organizationInfo: Organization;
  infoConfOrganizationUSA: Configuration;
  countryId: number;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  // loader
  loading = false;
  messageLoader = '';
  // alert
  generalAlerts: any[] = [];
  alertsFileExcel = [];
  // Config
  _action = 0;
  // header
  folio = '';
  // formulario
  txtUser = '';
  txtPerfil = '';
  typeInventory = -1;
  lsTypeInventory = [];
  storeId = -1;
  lsStores = [];
  brand = -1;
  lsBrand = [];
  section = -1;
  lsSection = [];
  gender = -1;
  lsGender = [];
  txtMarbetes = 0;
  txtCantidadPiezasSap = 0;
  captureTime = { hour: 0, minute: 0, second: 0 };
  flagGlbInv = false;
  // table
  rows: InventoryCountTag[] = [];
  rowFilters: InventoryCountFilter[] = [];
  // User data
  user: any = null;
  position: Position = null;
  nextId = 0;

  // permissions
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;
  accessedbystore = false;

  txtTagsQuantity: number = 0;
  visiblePrint = true;

  issueID = 1;
  pdfSrc: any = '';
  currentpage = 1;
  @ViewChild('warningModal') public warningModal: ModalDirective;
  showViewer = false;
  selectedTag: any = null;
  oHiddFrame = null;
  printAll = false;
  availablesOrganizations: Organization[] = [];
  tenantId = -1;
  availableStores: Store[] = [];

  public extras: NavigationExtras;
  public path = "inventory/counts/physical";
  public startDate: string;
  public endDate: string;
  public organization: string;
  public titleId: string;
  _id = 0;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private positionFacade: PositionFacade,
    private positionStoreFacade: PositionStoreFacade,
    private storeFacade: StoreFacade,
    private catDetFacade: CatalogDetFacade,
    private invCountFacade: InventoryCountFacade,
    private organizationFacade: OrganizationFacade,
    private configurationFacade: ConfigurationFacade,
    public datepipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    public strings: Strings
  ) { }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';
    this.tenantId = this.strings.getTenant();
    this.availableStores = this.strings.getAvailableStores();
    this.availablesOrganizations = this.strings.getAvailableOrganizations().filter(x => x.tenantId == this.tenantId);
    if (!this.isSpanish) {
      this.language = 1;
    }

    this.permissionsList = this._storage.get('permissions');
    this._action = Number(this.activatedRoute.snapshot.paramMap.get('id'));

    const navigation = this.activatedRoute.queryParams.subscribe((params) => {
      this._id = Number(params["id"]);
      this.startDate = params["startDate"];
      this.endDate = params["endDate"];
      this.organization = params["orgId"]
      this.titleId = params["titleId"]
      this.storeId = params["storeId"]
    });
    this.extras = {
      queryParams: {
        startDate: this.startDate,
        endDate: this.endDate,
        orgId: this.organization,
        titleId: this.titleId,
        storeId: this.storeId
      },
    };
    this._id = Number(this.activatedRoute.snapshot.paramMap.get("id"));  

    this.validatePermissions();
    if (this._action === 0) {
      this.getProfileInfo();
    } else {
      this.getInventoryCount();
    }
  }

  private getProfileInfo() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.user = this._storage.get('user');
    this.txtUser = this.user.name;
    // tslint:disable-next-line: deprecation
    if (this.accessedbystore) {
      this.loading = false;
      this.txtPerfil = '';
      this.position = new Position();
      this.getStores();
    } else {
      this.positionFacade.GetPositionByEmail(this.user.email).subscribe(
        response => {
          this.loading = false;
          this.txtPerfil = response.data.catDetJobName;
          this.position = response.data;
          this.getStores();
        }, error => {
          this.loading = false;
          this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertInventoriesCouldNotBeObtained), 'danger', 'general');
        }
      );
    }
  }

  private getStores() {
    //if (this.accessedbystore) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const stores = this.availableStores;
    stores.forEach(store => {
      if (this.availablesOrganizations.find(organization => organization.organizationId == store.organizationId) != undefined) {
        this.lsStores.push(store);
      }
    });
    this.storeId = -1;
    this.getTypeInventory();
    this.loading = false;
    /*
    // tslint:disable-next-line: deprecation
    this.storeFacade.GetByStoreEmail(this.user.email).subscribe(
      response => {
        this.loading = false;
        this.lsStores = response.data;
        this.getTypeInventory();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong>  ' +  this.strings.GetText(res.AlertInventoriesCouldNotBeObtained) , 'danger', 'general');
      }
    );
  } else if (this.position.allStores) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores) ;
    // tslint:disable-next-line: deprecation
    this.storeFacade.GetParticipateQuantum().subscribe(
      response => {
        this.loading = false;
        this.lsStores = response.data;
        this.getTypeInventory();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' +  this.strings.GetText(res.AlertStoresCouldNotBeObtained) , 'danger', 'general');
      }
    );
  } else {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores) ;
    // tslint:disable-next-line: deprecation
    this.positionStoreFacade.GetPositionStoreByPositionId(this.position.positionId).subscribe(
      response => {
        this.loading = false;
        this.lsStores = response.data;
        this.getTypeInventory();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' +  this.strings.GetText(res.AlertStoresCouldNotBeObtained) , 'danger', 'general');
      }
    );*/
    //}
  }

  private getTypeInventory() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingTheTypesOfInventories);
    // tslint:disable-next-line: deprecation
    this.catDetFacade.Get(38, this.language).subscribe(
      response => {
        this.loading = false;
        this.lsTypeInventory = response.data;
        this.getBrands();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getBrands() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingTheBrands);
    // tslint:disable-next-line: deprecation
    this.catDetFacade.Get(7, this.language, this.organizationId).subscribe(
      response => {
        this.loading = false;
        this.lsBrand = response.data;
        this.getSections();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertBrandsCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getSections() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingDepartments);
    // tslint:disable-next-line: deprecation
    this.catDetFacade.Get(5, this.language, this.organizationId).subscribe(
      response => {
        this.loading = false;
        this.lsSection = response.data;
        this.getGender();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertDepartmentsCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getGender() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingGenders);
    // tslint:disable-next-line: deprecation
    this.catDetFacade.Get(6, this.language, this.organizationId).subscribe(
      response => {
        this.loading = false;
        this.lsGender = response.data;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertGendersCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getInventoryCount() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    // tslint:disable-next-line: deprecation
    this.invCountFacade.GetInventoryCount(this._action, 0).subscribe(
      response => {
        this.loading = false;
        this.folio = response.data.code;
        this.txtPerfil = response.data.catDetJobName;
        this.txtUser = response.data.employeeName;
        this.getAllStores();
        this.typeInventory = response.data.catDetType;
        this.storeId = response.data.storeId;
        this.organizationId = response.data.organizationId;
        this.txtMarbetes = response.data.inventoryCountTagQuantity;
        this.rowFilters = response.data.inventoryCountFilters;
        this.rows = response.data.inventoryCountTags;
        this.txtCantidadPiezasSap = response.data.countSAP;
        const time = response.data.hourSAP.split(':');
        this.captureTime = { hour: +time[0], minute: +time[1], second: 0 };
        response.data.inventoryCountTags.sort((a, b) => a.invCountTagId - b.invCountTagId);
        for (let i = 0; i < response.data.inventoryCountTags.length; i++) {
          response.data.inventoryCountTags[i].canDelete = ((i + 1) === response.data.inventoryCountTags.length);
        }
        this.rows = response.data.inventoryCountTags;
        this.loadOrganizationInfo();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertInventoriesCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getAllStores() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);
    this.lsStores = [];
    // tslint:disable-next-line: deprecation
    this.storeFacade.GetParticipateQuantum().subscribe(
      response => {
        this.loading = false;
        const stores: Store[] = response.data;
        if (stores.length > 0) {
          stores.forEach(store => {
            if (this.availablesOrganizations.find(organization => organization.organizationId == store.organizationId) != undefined
              && this.availableStores.find(availablestore => availablestore.storeId == store.storeId) != undefined) {
              this.lsStores.push(store);
            }
          })
        }
        this.getTypeInventory();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong>  ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String) {
    if (fileType === 'excel') {
      this.alertsFileExcel = [];
      this.alertsFileExcel.push({
        type: type,
        msg: message
      });
    } else {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message
      });
    }

  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    if (fileType === 'excel') {
      this.alertsFileExcel = this.alertsFileExcel.filter(alert => alert !== dismissedAlert);
    } else {
      this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
    }
  }

  private padNumber(value: number, size: number) {
    let s = String(value);
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }

  private filterNotExist(): boolean {
    if (
      this.rowFilters.find(x =>
        x.catDetSectionId === this.section &&
        x.catDetBrandId === this.brand &&
        x.catDetGenderId === this.gender) == null
    ) {
      return true;
    }
    this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertFilterCombinationCannotBeRepeated), 'danger', 'general');
    return false;
  }

  private validateFormFilters(): boolean {
    let isValid = true;
    if (this.brand === -1) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustSelectTheBrand), 'danger', 'general');
    }
    if (this.section === -1) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustSelectTheDepartment), 'danger', 'general');
    }
    if (this.gender === -1) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustSelectTheGender), 'danger', 'general');
    }
    return isValid;
  }

  private validateFormMarbete(): boolean {
    let isValid = true;
    if (this.typeInventory === -1) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustSelectTheTypeInventory), 'danger', 'general');
    }
    if (this.storeId === -1) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustSelectTheStore), 'danger', 'general');
    }
    if (this.txtMarbetes === 0) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertNumberTagsMustBegreater), 'danger', 'general');
    }
    return isValid;
  }

  private validateAllForm(): boolean {
    let isValid = true;
    if (!this.validateFormMarbete()) {
      isValid = false;
    }
    if (this.rows.length === 0) {
      isValid = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustGenerateTheTags), 'danger', 'general');
    }
    if (this.typeInventory == CatalogDetInfo.InvetoryPartialType) {
      if (this.rowFilters.length === 0) {
        isValid = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustGenerateAtLeastOneFilter), 'danger', 'general');
      }
    }
    /*if (this.typeInventory === 163) {
      if (this.txtCantidadPiezasSap <= 0) {
        isValid = false;
        this.addAlert('<strong>¡Error!</strong> La cantidad de piezas SAP debe ser mayor a 0', 'danger', 'general');
      }
    }*/
    return isValid;
  }

  onChangeStore(e) {
    this.rows = [];
    this.txtMarbetes = 0;
    const tmpStore = this.lsStores.find(x => x.storeId == e);
    if (tmpStore != undefined) {
      this.countryId = parseInt(tmpStore.catDetCountryId.toString());
      if (tmpStore.migrateNS) {
        this.organizationId = tmpStore.organizationId;
        this.loadOrganizationInfo();
      } else {
        this.organizationId = null;
      }
    } else {
      this.organizationId = null;
    }
    this.getGender();
    this.getBrands();
  }

  // agregar Filtro
  createFilter() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GeneratingFilter);
    if (this.validateFormFilters()) {
      const invFil = new InventoryCountFilter();
      invFil.invCountFilId = this.rowFilters.length;
      invFil.catDetSectionId = this.section;
      invFil.catDetGenderId = this.gender;
      invFil.catDetBrandId = this.brand;
      // tslint:disable-next-line: triple-equals
      invFil.catDetSectionName = this.lsSection.find(x => x.catDetId == this.section).name;
      // tslint:disable-next-line: triple-equals
      invFil.catDetGenderName = this.lsGender.find(x => x.catDetId == this.gender).name;
      // tslint:disable-next-line: triple-equals
      invFil.catDetBrandName = this.lsBrand.find(x => x.catDetId == this.brand).name;
      if (this.filterNotExist()) {
        this.rowFilters.push(invFil);
      }
    }
    this.loading = false;
  }

  // agregar marbetes
  createMarbete() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GeneratingTags);
    if (this.validateFormMarbete()) {
      // tslint:disable-next-line: deprecation
      this.invCountFacade.GetNextIdForStore(this.storeId).subscribe(
        response => {
          this.loading = false;
          this.nextId = response.data;
          this.rows = [];
          for (let i = 0; i < this.txtMarbetes; i++) {
            const invTag = new InventoryCountTag();
            invTag.invCountTagId = i + 1;
            invTag.invCountId = response.data;
            invTag.code = this.padNumber(this.storeId, 3) + '_' + this.padNumber(response.data, 4) + '_' + this.padNumber(i + 1, 3);
            if (this.infoConfOrganizationUSA != null && this.infoConfOrganizationUSA.value.includes(this.organizationId, 0)) {
              invTag.name = 'Tag ' + (i + 1);
            } else {
              invTag.name = 'Marbete ' + (i + 1);
            }
            invTag.canDelete = (i + 1) === this.txtMarbetes;
            this.rows.push(invTag);
          }
        }, error => {
          this.loading = false;
          this.addAlert(
            '<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertCouldNotGetTheNextInventoryNumber) + ': ' + this.storeId,
            'danger', 'general');
        }
      );
    } else {
      this.loading = false;
    }
  }

  // delete Marbete
  deleteMarbete(id) {
    if (this._action === 0) {
      if (this.txtMarbetes > 1) {
        this.txtMarbetes = this.txtMarbetes - 1;
        this.createMarbete();
      } else {
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustHaveAtLeastOneTag), 'danger', 'general');
      }
    } else {
      this.deleteOneMarbete(id);
    }
  }

  // delete Filtro
  deleteFiltro(id) {
    this.rowFilters.splice(this.rowFilters.indexOf(id), 1);
  }

  // Save Edit inventario
  saveInventario() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GeneratingInventory);
    this.validatePermissions();
    if (this.validateAllForm() && this.visibleAdd && this._action == 0) {
      const inv = new InventoryCount();
      inv.code = '8' + this.padNumber(this.storeId, 3) + '_' + this.padNumber(this.nextId, 4) + '_'
        + this.datepipe.transform(new Date(), 'yyMMdd');
      inv.catDetType = this.typeInventory;
      inv.storeId = this.storeId;
      inv.inventoryCountTags = this.rows;
      inv.inventoryCountFilters = this.rowFilters;
      inv.countSAP = this.txtCantidadPiezasSap;
      if (this.countryId == CatalogDetInfo.catDetCountryUSAId) {
        inv.organizationId = this.organizationId;
      } else {
        inv.organizationId = null;
      }
      this.captureTime = { hour: + '09', minute: + '00', second: 0 };
      inv.hourSAP = this.getTime(this.captureTime);
      inv.language = this.language;
      // tslint:disable-next-line: deprecation
      this.invCountFacade.saveInventoryCount(inv).subscribe(
        response => {
          this.loading = false;
          if (response.completed) {
            // this.justPrint();
            this.typeInventory = -1;
            this.storeId = -1;
            this.brand = -1;
            this.section = -1;
            this.gender = -1;
            this.txtMarbetes = 0;
            this.rows = [];
            this.rowFilters = [];
            this.addAlert('<strong>' + response.message + '</strong>', 'success', 'general');
          } else {
            this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'general');
          }
        }, error => {
          this.loading = false;
          this.addAlert(
            '<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertUnableSaveInventoryForTheStore) + ': ' + this.storeId, 'danger', 'general');
        }
      );
    } else if (
      this.validateAllForm() &&
      this.visibleEdit &&
      this._action != 0
    ) {
      const inv = new InventoryCount();
      inv.code = this.folio;
      inv.catDetJobName = this.txtPerfil
      inv.employeeName = this.txtUser;
      inv.catDetType = this.typeInventory;
      inv.storeId = this.storeId;
      inv.organizationId = this.organizationId;
      inv.inventoryCountTagQuantity = this.txtMarbetes;
      inv.inventoryCountFilters = this.rowFilters;
      inv.inventoryCountTags = this.rows;
      inv.countSAP = this.txtCantidadPiezasSap;
      this.captureTime = { hour: +"09", minute: +"00", second: 0 };
      inv.hourSAP = this.getTime(this.captureTime);
      inv.language = this.language;

      this.invCountFacade.UpdateInventoryCount(inv).subscribe(
        (response) => {
          this.loading = false;
          this.addAlert(
            "<strong> " +
            this.strings.GetText(res.AlertTheDataHasBeenUpdatedSuccessfully) +
            "</strong>",
            "success",
            "general"
          );
        },
        (error) => {
          this.loading = false;
          this.addAlert(
            "<strong>¡Error!</strong> " +
            this.strings.GetText(res.AlertInventoryDataCouldNotBeObtained),
            "danger",
            "general"
          );
        }
      )
    } else {
      if (!this.visibleAdd || !this.visibleEdit) {
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouDoNotHavePermissionsToPerformThisAction), 'danger', 'general');
      }
      this.loading = false;
    }
  }

  getTime(time): string {
    return time.hour + ':' + time.minute + ':00';
  }

  textToBase64Barcode(text) {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, text, {
      format: 'CODE128',
      fontOptions: 'bold',
      displayValue: false
    });
    return canvas.toDataURL('image/png');
  }

  beginPrintAll() {
    this.issueID = -1;
    this.printAll = true;
    this.printNext();
  }

  printNext() {
    this.issueID = this.issueID + 1;
    if (this.issueID < this.rows.length) {
      this.justPrintOne(this.rows[this.issueID]);
    } else {
      this.printAll = false;
    }
  }

  justPrintAll() {
    if (this.rows.length > 0) {
      const doc = new jsPDF();
      if (document.body.contains(this.oHiddFrame)) {
        document.body.removeChild(this.oHiddFrame);
      }
      this.warningModal.hide();
      for (let i = 0; i < this.rows.length; i++) {
        const imgData = this.textToBase64Barcode(this.rows[i].code);
        let myDate: string;
        this.countryId = parseInt(this.lsStores.find(x => x.storeId == this.storeId).catDetCountryId.toString());
        if (this.countryId == CatalogDetInfo.catDetCountryUSAId) {
          myDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        } else {
          myDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
        }

        doc.setLineWidth(1);
        doc.rect(20, 20, 170, 250); // Contorno de todo marbete

        // doc.rect(20, 20, 170, 95);

        doc.rect(20, 115, 170, 40); // Folio 3 digitos

        doc.rect(20, 155, 57, 115);
        doc.rect(20, 155, 57, 40);
        doc.rect(77, 155, 57, 115);
        doc.rect(77, 155, 57, 40);
        doc.rect(134, 155, 56, 115);
        doc.rect(134, 155, 56, 40);

        doc.setFontSize(25);

        const tradeMark = this.lsStores.find(x => x.storeId === this.storeId).tradeMark.toLowerCase();

        if (this.infoConfOrganizationUSA != null
          && this.infoConfOrganizationUSA.value.split(',').find(x => x == this.organizationId) != null) {
          doc.text(this.organizationInfo.name, 80 - this.organizationInfo.name.length, 35);
        } else if (tradeMark === 'ch') {
          doc.text('INTER TENIS S.A. DE C.V.', 55, 35);
        } else {
          doc.text('MANHATTHAN', 80, 35);
        }

        doc.setLineWidth(0.5);
        doc.line(32, 38, 180, 38);

        doc.setFontSize(22);
        doc.text(this.strings.GetText(res.Tag) + ': ' + this.rows[i].code, 32, 49);
        doc.addImage(imgData, 'JPEG', 28, 50, 155, 55);

        doc.setFontSize(25);
        doc.text(this.strings.GetText(res.Date) + ': ', 32, 111);
        doc.text(myDate, 135, 111);

        doc.setFontSize(95);
        doc.text(this.rows[i].code.substr(9, 3), 130, 147);

        doc.setFontSize(55);
        doc.text('1', 45, 178);
        doc.text('2', 100, 178);
        doc.text('3', 155, 178);

        doc.setFontSize(25);
        doc.text(this.strings.GetText(res.Counting), 35, 190);
        doc.text(this.strings.GetText(res.Validation), 85, 190);
        doc.text(this.strings.GetText(res.Scanning), 145, 190);
        if (i + 1 < this.rows.length) {
          doc.addPage();
        }
      }
      // doc.save('Marbetes.pdf');
      doc.autoPrint();
      this.oHiddFrame = document.createElement('iframe');
      this.oHiddFrame.style.position = 'fixed';
      this.oHiddFrame.style.visibility = 'hidden';
      this.oHiddFrame.src = '' + doc.output('bloburl');
      document.body.appendChild(this.oHiddFrame);
      // window.open(doc.output('bloburl'), '_blank');
    } else {
      // tslint:disable-next-line: max-line-length
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertYouMustCreateTheTagsBeforePrintingThem), 'danger', 'general');
    }
  }

  addTags() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.AddingTag);
    // tslint:disable-next-line: deprecation

    if (this.txtTagsQuantity > 0) {
      this.invCountFacade.GetNextIdForStore(this.storeId).subscribe(
        response => {
          this.loading = false;
          this.loading = true;
          this.messageLoader = this.strings.GetText(res.AddingTag);
          const tags: InventoryCountTag[] = [];

          for (let i = 1; i <= this.txtTagsQuantity; i++) {
            const invTag = new InventoryCountTag();
            invTag.invCountTagId = this.txtMarbetes + i;
            invTag.invCountId = this._action;
            invTag.code = this.padNumber(this.storeId, 3) + '_'
              + this.padNumber(response.data - 1, 4) + '_' + this.padNumber(this.txtMarbetes + i, 3);

            if (this.infoConfOrganizationUSA != null
              && this.infoConfOrganizationUSA.value.split(',').find(x => x == this.organizationId) != null) {
              invTag.name = 'Tag ' + (this.txtMarbetes + i);
            } else {
              invTag.name = 'Marbete ' + (this.txtMarbetes + i);
            }
            tags.push(invTag);
          }
          this.txtTagsQuantity = 0;
          this.invCountFacade.AddMultipleInventoryCountTag(tags).subscribe(
            response => {
              if (response.completed) {
                this.loading = false;
                this.getInventoryCount();
              } else {
                this.loading = false;
                this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTagCouldNotBeAdded), 'danger', 'general');
              }
            }, error => {
              this.loading = false;
              this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTagCouldNotBeAdded), 'danger', 'general');
            }
          );
        }, error => {
          this.loading = false;
          this.addAlert(
            '<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertCouldNotGetTheNextInventoryNumber) + ': ' + this.storeId,
            'danger', 'general');
        });
    } else {
      this.loading = false;
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertNumberTagsMustBegreater), 'danger', 'general');
    }
  }

  deleteOneMarbete(id) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.RemovingTag);
    // tslint:disable-next-line: deprecation
    this.invCountFacade.DeleteInventoryCountTag(id).subscribe(
      response => {
        this.loading = false;
        this.getInventoryCount();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.TagCouldNotBeDeleted), 'danger', 'general');
      }
    );
  }

  justPrintOne(item, pdf = false) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.PrintingTags); // 'Imprimiendo marbete';
    this.selectedTag = item;
    if (document.body.contains(this.oHiddFrame)) {
      document.body.removeChild(this.oHiddFrame);
    }
    this.warningModal.hide();
    this.pdfSrc = '';
    const doc = new jsPDF();
    const imgData = this.textToBase64Barcode(this.selectedTag.code);

    this.countryId = parseInt(this.lsStores.find(x => x.storeId == this.storeId).catDetCountryId.toString());
    let myDate: string
    if (this.countryId == CatalogDetInfo.catDetCountryUSAId) {
      myDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    } else {
      myDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    doc.setLineWidth(1);
    doc.rect(20, 20, 170, 250); // Contorno de todo marbete

    // doc.rect(20, 20, 170, 95);

    doc.rect(20, 115, 170, 40); // Folio 3 digitos

    doc.rect(20, 155, 57, 115);
    doc.rect(20, 155, 57, 40);
    doc.rect(77, 155, 57, 115);
    doc.rect(77, 155, 57, 40);
    doc.rect(134, 155, 56, 115);
    doc.rect(134, 155, 56, 40);

    doc.setFontSize(25);

    const tradeMark = this.lsStores.find(x => x.storeId === this.storeId).tradeMark.toLowerCase();
    if (this.infoConfOrganizationUSA != null
      && this.infoConfOrganizationUSA.value.split(',').find(x => x == this.organizationId) != null) {
      doc.text(this.organizationInfo.name, 80 - this.organizationInfo.name.length, 35);
    } else if (tradeMark === 'ch') {
      doc.text('INTER TENIS S.A. DE C.V.', 55, 35);
    } else {
      doc.text('MANHATTHAN', 80, 35);
    }

    doc.setLineWidth(0.5);
    doc.line(32, 38, 180, 38);

    doc.setFontSize(22);
    doc.text(this.strings.GetText(res.Tag) + ': ' + this.selectedTag.code, 32, 49);
    doc.addImage(imgData, 'JPEG', 28, 50, 155, 55);

    doc.setFontSize(25);
    doc.text(this.strings.GetText(res.Date) + ': ', 32, 111);
    doc.text(myDate, 135, 111);

    doc.setFontSize(95);
    doc.text(this.selectedTag.code.substr(9, 3), 130, 147);

    doc.setFontSize(55);
    doc.text('1', 45, 178);
    doc.text('2', 100, 178);
    doc.text('3', 155, 178);

    doc.setFontSize(25);
    doc.text(this.strings.GetText(res.Counting), 35, 190);
    doc.text(this.strings.GetText(res.Validation), 85, 190);
    doc.text(this.strings.GetText(res.Scanning), 145, 190);

    // doc.save('Marbetes.pdf');
    doc.autoPrint();
    if (pdf) {
      this.oHiddFrame = document.createElement('iframe');
      this.oHiddFrame.style.position = 'fixed';
      this.oHiddFrame.style.visibility = 'hidden';
      this.oHiddFrame.src = '' + doc.output('bloburl');
      document.body.appendChild(this.oHiddFrame);
      this.loading = false;
    } else {
      this.showViewer = true;
      const pd = doc.output('arraybuffer');
      this.pdfSrc = pd;
    }
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    setTimeout(function () {
      html2canvas(document.getElementById('pruebain') as HTMLElement).then((canvas: any) => {
        const ctxO = canvas.getContext('2d');
        ctxO.scale(0.5, 0.5);
        const compressImage = (src, newX, newY) => {
          return new Promise<string>((reso, rej) => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
              const elem = document.createElement('canvas');
              elem.width = newX;
              elem.height = newY;
              const ctx = elem.getContext('2d');
              ctx.drawImage(img, 0, 0, newX, newY);
              const data = ctx.canvas.toDataURL();
              reso(data);
            };
            img.onerror = error => rej(error);
          });
        };

        compressImage(canvas.toDataURL(), 530, 810).then(compressed => {
          setPosId(1);
          checkPrinterStatus();
          printBitmap(compressed, -2, 1, false);
          printText('\n\n\n\n\n', 0, 0, false, false, false, 0, 0);
          cutPaper();
          const strSubmit = getPosData();

          requestPrint('Printer1', strSubmit, (result) => {
            $('#closePrintLoading').click();
            if (!result.includes('success')) {
              $('#showPrintError').click();
            } else {
              $('#printNextLoading').click();
            }
          });
        }).catch((reason) => {
          // this.addAlert('<strong>¡Error!</strong> ' + reason, 'danger', 'general')
        });
      });
    }, 4000);
  }

  validatePermissions() {
    this.permissionsList.forEach(element => {
      // tslint:disable-next-line: triple-equals
      if (element.name == Permissions.GeneralAccess || element.name == Permissions.InventarioConteoCreate
        || Permissions.InventarioFisicoCreate) {
        this.visibleAdd = true;
      }
      if (element.name == Permissions.GeneralAccess || element.name == Permissions.InventarioConteoEdit
        || Permissions.InventarioFisicoEdit) {
        this.visibleEdit = true;
      }
      if (element.name == Permissions.MobileAccess) {
        this.accessedbystore = true;
      }

    });

    /*this.permissionsList.forEach(element => {
      // tslint:disable-next-line: triple-equals
        if (element.name == Permissions.GeneralAccess || element.name == Permissions.InventarioConteoEdit
           || Permissions.InventarioFisicoEdit) {
      this.visibleEdit = true;
    }
  });*/
  }

  validateInventory() {
    // tslint:disable-next-line: triple-equals
    if (this.typeInventory == 163) {
      this.flagGlbInv = true;
      this.txtCantidadPiezasSap = 0;
    } else {
      this.flagGlbInv = false;
    }
  }

  loadOrganizationInfo() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingOrganization);
    if (this.organizationId != null) {
      this.organizationFacade.GetByOrganization(this.organizationId).subscribe(response => {
        if (response.completed && response.data != null) {
          this.organizationInfo = response.data;
        }
        this.loadConfigurationInfo();
        this.loading = false;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOrganizationInfoCouldNotBeObtained), 'danger', 'general');
      });
    }
  }
  loadConfigurationInfo() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingEnglishOrganization);
    if (this.organizationId != null) {
      this.configurationFacade.GetConfiguration(ConfigurationInfo.infoConfOrganizationUSA).subscribe(response => {
        if (response.completed && response.data != null) {
          this.infoConfOrganizationUSA = response.data;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> '
          + this.strings.GetText(res.AlertConfigurationInfoCouldNotBeObtained), 'danger', 'general');
      });
    }
  }
}
